import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { loadRuntimeConfig } from './utils/runtimeConfig';
import { initializeFirebaseClient } from './utils/firebase';
import { captureEmailActionFromLocation } from './utils/emailVerification';

export async function bootstrapApplication({
  rootElement = typeof document !== 'undefined' ? document.getElementById('root') : null,
  createRootImpl = ReactDOM.createRoot,
  loadRuntimeConfigImpl = loadRuntimeConfig,
  initializeFirebaseImpl = initializeFirebaseClient,
} = {}) {
  if (!rootElement) return null;
  const root = createRootImpl(rootElement);

  try {
    const runtimeConfig = await loadRuntimeConfigImpl();
    captureEmailActionFromLocation({ config: runtimeConfig });
    initializeFirebaseImpl(runtimeConfig);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
    return { ok: true, runtimeConfig };
  } catch (error) {
    console.error('[startup] Frontend runtime configuration failed:', error?.message || error);
    root.render(
      <React.StrictMode>
        <div
          role="alert"
          data-testid="runtime-config-error"
          style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '24px',
            fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
          }}
        >
          <div style={{ maxWidth: '520px' }}>
            <h1 style={{ fontSize: '20px', marginBottom: '12px' }}>
              Application configuration unavailable
            </h1>
            <p style={{ margin: 0, lineHeight: 1.5 }}>
              Featherglass could not verify the runtime environment configuration for this deployment.
              Please contact an administrator.
            </p>
          </div>
        </div>
      </React.StrictMode>
    );
    return { ok: false, error };
  }
}

if (typeof document !== 'undefined' && document.getElementById('root')) {
  bootstrapApplication();
  reportWebVitals();
}
